import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { tenantPermissionResourceFilters } from './tenant-permission-resource.filters';

// `validateSearch` das duas rotas (U07). Leve de propósito: é JS inicial.

export const TENANT_PERMISSION_RESOURCE_PATH = '/seguranca/recursos-correspondente';
/** Id do cadastro novo na URL, como o legado (`…/novo`). */
export const NEW_TENANT_PERMISSION_RESOURCE = 'novo';
export const tenantPermissionResourcePath = (id: string) =>
  `${TENANT_PERMISSION_RESOURCE_PATH}/${encodeURIComponent(id)}`;

/** Tamanhos do legado: 5/10/15/20/60 (`TenantPermissionResourceList.tsx:131`). */
export const TENANT_PERMISSION_RESOURCE_PAGE_SIZES = [5, 10, 15, 20, 60] as const;

/** Página (a partir de 1), tamanho, o filtro Correspondente e o sheet de filtros do iPhone. */
export const tenantPermissionResourceListSearch = listSearchSchema(
  {
    ...tenantPermissionResourceFilters.shape,
    sheet: z.string().min(1).max(40).optional().catch(undefined),
  },
  { sizes: TENANT_PERMISSION_RESOURCE_PAGE_SIZES },
);
export type TenantPermissionResourceListSearch = z.infer<typeof tenantPermissionResourceListSearch>;

/** O formulário não tem abas nem filtros na URL. */
export const tenantPermissionResourceFormSearch = z.object({});
